import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { NotificationCampaign, NotificationCampaignCreate, NotificationCampaignFilter } from '../data/notificationCampaign';

export function createNotificationCampaignService(client: AxiosInstance) {
  return createCrudService<NotificationCampaign, NotificationCampaignCreate, NotificationCampaignFilter>(
    client,
    '/notifications/NotificationCampaign',
    'id',
  );
}

export type NotificationCampaignService = CrudService<NotificationCampaign, NotificationCampaignCreate, NotificationCampaignFilter>;
